import React, { useState, useEffect } from 'react';
import axios from '../components/services/axiosInstance';
import { FaTimes, FaCalendar, FaMoneyBillWave } from 'react-icons/fa';
import './DailyPaymentPopup.css';

const DailyPaymentPopup = ({ onPaymentConfirmed, onViewDetails }) => {
    const [show, setShow] = useState(false);
    const [todayPayments, setTodayPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAndShowPopup();
    }, []);

    const checkAndShowPopup = async () => {
        // Check if popup was already shown today
        const lastShown = localStorage.getItem('dailyPaymentPopupLastShown');
        const today = new Date().toDateString();

        if (lastShown === today) {
            setLoading(false);
            return; // Already shown today
        }

        // Fetch today's payments
        try {
            const response = await axios.get('/payments/today');
            if (response.data.success && response.data.todayPayments.length > 0) {
                setTodayPayments(response.data.todayPayments);
                setShow(true);
            }
        } catch (error) {
            console.error('Error fetching today payments:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirm = () => {
        // Mark as shown for today
        const today = new Date().toDateString();
        localStorage.setItem('dailyPaymentPopupLastShown', today);
        setShow(false);
        if (onPaymentConfirmed) {
            onPaymentConfirmed();
        }
    };

    const formatCurrency = (amount) => {
        return `${amount.toLocaleString('ar-TN')} TND`;
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('ar-TN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading || !show || todayPayments.length === 0) {
        return null;
    }

    return (
        <div className="daily-payment-overlay">
            <div className="daily-payment-popup">
                <div className="popup-header">
                    <h2>📋 الدفعات المستحقة اليوم</h2>
                    <p className="popup-date">{formatDate(new Date())}</p>
                </div>

                <div className="popup-body">
                    <div className="payments-list">
                        {todayPayments.map((installment) => (
                            <div
                                key={installment._id}
                                className="payment-card"
                                onClick={() => onViewDetails && onViewDetails(installment.paymentId)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="card-header">
                                    <div className="student-info">
                                        <h4>{installment.paymentId?.studentId?.username}</h4>
                                        <span className="installment-number">
                                            القسط رقم {installment.installmentNumber}
                                        </span>
                                    </div>
                                    <div className="amount-badge">
                                        {formatCurrency(installment.amount)}
                                    </div>
                                </div>

                                <div className="card-details">
                                    <div className="detail-row">
                                        <span className="label">هاتف الطالب:</span>
                                        <span className="value">
                                            {installment.paymentId?.studentId?.phoneNumber || 'غير متوفر'}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="label">هاتف ولي الأمر:</span>
                                        <span className="value">
                                            {installment.paymentId?.studentId?.parentPhoneNumber || 'غير متوفر'}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="label">المجموع الكلي:</span>
                                        <span className="value">
                                            {formatCurrency(installment.paymentId?.totalAmount)}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="label">المتبقي:</span>
                                        <span className="value text-warning">
                                            {formatCurrency(installment.paymentId?.remainingAmount)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="popup-footer">
                    <button className="btn-confirm" onClick={handleConfirm}>
                        تأكيد وإغلاق
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DailyPaymentPopup;
